import { render, staticRenderFns } from "./TabControl.vue?vue&type=template&id=6ff624ae&"
import script from "./TabControl.vue?vue&type=script&lang=js&"
export * from "./TabControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports